<template>
    <div>
        <CDataTable
        :items="this.$store.state.auctionList"
        :fields="[{key:'team_name', label:'', filter:false, sorter:false}, {key:'last_name', label:'Player'}, {key:'original_cost', label:'Cost'}, {key:'total_points', label:'Total'}, {key:'player_id', label:'', filter:false, sorter:false}]"
        :tableFilter=true
        sorter
        hover
        striped
        bordered
        small
        fixed
    >
        <template #team_name="{item}">
        <td>
            <img width="24px" height="32px" :src="'img/team-kits/shirt_' + item.team_name_short + '-66.webp'" :alt="item.team_name" />
        </td>
        </template>
        <template #last_name="{item}">
          <TablePlayerItem :item="item" />
        </template>
        <template #player_id="{item}">
        <td>
            <CButton block :disabled="!biddingOpen" variant="outline" :color="biddingOpen ? 'primary' : 'secondary'" size="sm" :id="item.player_id" @click="showBidModal(item.player_id)">Bid</CButton>
        </td>
        </template>
        </CDataTable>
        <CModal
        :title="selectedPlayer.last_name"
        :show.sync="bidModal"
        color="primary"
        >
            <template>
                <CInput label="Bid amount: " placeholder="2.50" v-model="bidValue" invalid-feedback="Bids must be minumum 2.50" :is-valid="validateBidValue" type="number" />
            </template>
            <template v-slot:footer>
                <CButton color="secondary" @click="bidModal = false">Cancel</CButton>
                <CButton color="primary" @click="placeBid()">Place Bid</CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
import TablePlayerItem from '../base/TablePlayerItem.vue'

export default {
  name: 'PlaceBid',
  components: { TablePlayerItem },
  data () {
    return {
      bidModal: false,
      selectedPlayer: {},
      bidValue: 2.50,
      invalidBidMessage: "123"
    }
  },
  created() {
    this.$store.dispatch("loadAuctionList");
  },
  computed: {
    biddingOpen: function() {
      for(var i = 0; i < this.$store.state.siteVarsList.list.length; i++) {
        if(this.$store.state.siteVarsList.list[i].name == "bidding_open" && this.$store.state.siteVarsList.list[i].value == "true") {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    showBidModal: function(player_id) {
      var auctionList = this.$store.state.auctionList;
      for(var i = 0; i < auctionList.length; i++) {
        if(auctionList[i].player_id == player_id) {
          this.selectedPlayer = auctionList[i];
          break;
        }
      }

      this.bidModal = true;
    },
    placeBid: function() {
      var isValid = this.validateBidValue(this.bidValue);

      if(isValid && this.$auth.isAuthenticated) {
        this.$store.dispatch("savePlaceBid", {playerId:this.selectedPlayer.player_id,
                                              playerName:this.selectedPlayer.last_name,
                                              position:this.selectedPlayer.position_short,
                                              teamName:this.selectedPlayer.team_name_short,
                                              clubId:this.$auth.user['https://tlog-online.co.uk/club_id'],
                                              amount: this.bidValue});
        this.bidModal = false;
      }
    },
    validateBidValue: function(value) {
      var num = Number(value);

      return num >= 2.5;
    }
  }
}
</script>